/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_ElsewhereInputs */



/**
* | output |
* | --- |
* | "Somewhere else" |
*
* @param {Tournament_Wiz_Home_ElsewhereInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_elsewhere = /** @type {((inputs?: Tournament_Wiz_Home_ElsewhereInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_ElsewhereInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ailleurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("En otro sitio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Em outro lugar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Da un'altra parte")
	return /** @type {LocalizedString} */ ("Somewhere else")
});